<!--
   Created by qing on 2020/12/23
   Des: 
-->
<template>
  <van-popup
    class="form-data-view-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    :style="{ height: '100%', width: '100%' }"
    get-container="body"
    @close="beforeClose"
    position="right">
    <div class="form-data-view-popup-container" v-if="visibleInfo.visible">
      <FormDataView
        :form-id="formId"
        :app-id="appId"
        :view-id="viewId"
        :view-type="viewType"
        :hasAddForm="false"
        :active-relate-form="{filterInfo: null}"
        clickRowTips="查看数据详情后，返回会跳转至第一级目录，是否继续？">
      </FormDataView>
    </div>
  </van-popup>
</template>

<script>
  import {FORM_VIEW_TYPE_DATA_HANDLE, FORM_VIEW_TYPE_DATA_VIEW} from "../../../assets/types";
  import FormDataView from "../FormDataView";

  export default {
    props: {
      stackList: {
        type: Array,
        default: () => []
      }
    },
    components: {FormDataView},
    data() {
      return {
        visibleInfo: {
          visible: false
        },
        formId: '',
        appId: '',
        viewId: '',
        viewType: FORM_VIEW_TYPE_DATA_VIEW
      }
    },
    created() {
    },
    methods: {
      open({formId, appId, viewId}) {
        this.formId = formId
        this.appId = appId
        this.viewId = viewId
        if (this.viewId === FORM_VIEW_TYPE_DATA_HANDLE) {
          this.viewType = FORM_VIEW_TYPE_DATA_HANDLE
        } else {
          this.viewType = FORM_VIEW_TYPE_DATA_VIEW
        }
        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
      },
      beforeClose() {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="less">

  .form-data-view-popup {

    .form-data-view-popup-container {
      width: 100%;
      height: calc(100% - env(safe-area-inset-bottom));
    }
  }
</style>